/*
  PDP-Baukasten — gemeinsames Verhalten (markenneutral)
  1. Einblenden beim Scrollen ([data-pdp-reveal])
  2. Hotspot-Karte: Seite umschalten, Punkt <-> Liste koppeln
  3. Button "zur Kaufbox" ([data-pdp-to-buy]): scrollt zur Kaufbox.
     Ziel = data-pdp-target am Button, sonst das erste Warenkorb-Formular.
  Mehrfach eingebunden ist harmlos — laeuft nur einmal.
*/
(function () {
  if (window.__pdpInit) return;
  window.__pdpInit = true;
  document.documentElement.classList.add('pdp-js');

  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-pdp-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function zones(root) {
    (root || document).querySelectorAll('[data-pdp-zones]').forEach(function (sec) {
      if (sec.__pdp) return; sec.__pdp = true;
      var tabs = sec.querySelectorAll('[data-pdp-side-tab]');
      var stages = sec.querySelectorAll('[data-pdp-stage]');
      var items = sec.querySelectorAll('[data-pdp-zone]');

      function showSide(side) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-pdp-side-tab') === side;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        stages.forEach(function (s) { s.hidden = s.getAttribute('data-pdp-stage') !== side; });
        if (sec.hasAttribute('data-pdp-side')) sec.setAttribute('data-pdp-side', side);
      }
      function activate(id, fromList) {
        items.forEach(function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-pdp-zone') === id);
        });
        if (fromList) {
          var dot = sec.querySelector('.pdp-hs__dot[data-pdp-zone="' + id + '"]');
          if (dot) showSide(dot.closest('[data-pdp-stage]').getAttribute('data-pdp-stage'));
        }
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { showSide(t.getAttribute('data-pdp-side-tab')); });
      });
      items.forEach(function (el) {
        var id = el.getAttribute('data-pdp-zone');
        var isList = !el.classList.contains('pdp-hs__dot');
        el.addEventListener('mouseenter', function () { activate(id, isList); });
        el.addEventListener('focus', function () { activate(id, isList); });
        el.addEventListener('click', function () { activate(id, isList); });
      });
    });
  }

  function toBuy(root) {
    (root || document).querySelectorAll('[data-pdp-to-buy]').forEach(function (btn) {
      if (btn.__pdp) return; btn.__pdp = true;
      btn.addEventListener('click', function (ev) {
        var sel = btn.getAttribute('data-pdp-target');
        var target = (sel && document.querySelector(sel)) || document.querySelector('form[action*="/cart/add"]');
        if (!target) return;
        ev.preventDefault();
        var y = target.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: y, behavior: 'smooth' });
        var atc = target.querySelector('[type="submit"][name="add"], button[type="submit"]');
        if (atc) setTimeout(function () { atc.focus({ preventScroll: true }); }, 600);
      });
    });
  }

  function init(root) { reveal(root); zones(root); toBuy(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
